import Graphic from "@arcgis/core/Graphic";
import { SearchViewModal } from "../../lib/widget/Search/searchViewModal";
import { newPos, toggleRoofConfirmBtn } from "../../ReduxTool/Slice/Map/MapReducer";
import { setLocationPinLatLng } from "../../ReduxTool/Slice/Marker/MarkersReducer";
import { LocationMarker } from "../Const";
import globalLayers from "../CustomerMaps/Maps/GlobaLMap";
import { loadMultipleModules } from "../CustomerMaps/Maps/LazyloadMap";
import { markerSymbol } from "../CustomerMaps/MarkerSymbols/MarkerSymbols";
import { AppDispatch } from "../../ReduxTool/store/store";

export const addMarkerToMap = async (dispatch: AppDispatch, addMarker?: string, showConfirmation = false) => {
    let { userCurrentLocation: { lat, lng } } = globalLayers;
    const point = {
        type: "point",
        longitude: lng,
        latitude: lat,
    };

    const [SketchViewModel, Graphic] = await loadMultipleModules(["esri/widgets/Sketch/SketchViewModel", "esri/Graphic", "esri/geometry/support/webMercatorUtils"]);
        let pointGraphic = new Graphic({
            geometry: point as any,
            symbol: markerSymbol as any,
            attributes: {
                name: LocationMarker
            }
        });
        globalLayers.LocationMarkerPointGraphic = pointGraphic;
        globalLayers.graphicLayerLocation?.graphics.forEach((ele: Graphic) => {              
            if (ele.attributes && ele.attributes.name === LocationMarker) {
                globalLayers.graphicLayerLocation?.graphics.remove(ele);
            }
        });     
        
        if((addMarker === undefined || !addMarker) && globalLayers.sketchLayers?.graphics.length === 0){
            globalLayers.graphicLayerLocation?.graphics.addMany([pointGraphic]);
            
            if(globalLayers.sketchViewModel){
                (globalLayers.sketchViewModel as __esri.SketchViewModel).destroy()
            }
            globalLayers.sketchViewModel = new SketchViewModel({
                view: globalLayers.view!,
                layer: globalLayers.graphicLayerLocation!,
                updateOnGraphicClick: true,
                // multipleSelectionEnabled: true,
                defaultUpdateOptions: {
                    toggleToolOnClick: true,
                    tool: "reshape",
                }
            });
            if (showConfirmation) {
                dispatch(setLocationPinLatLng({ lat, lng }));
                const screenPoint = globalLayers.view?.toScreen(pointGraphic.geometry as __esri.Point);
                if (screenPoint) dispatch(newPos({ x: screenPoint.x, y: screenPoint.y }));
                dispatch(toggleRoofConfirmBtn(true));
            }
        }

        const handlePosition = (event: MouseEvent) => {
            globalLayers.lastCursorPositionSelected = { x: event.offsetX, y: event.offsetY };
            dispatch(newPos(globalLayers.lastCursorPositionSelected!))
        }
        document.addEventListener("mouseup", (event) => handlePosition(event));
        SearchViewModal(dispatch, handlePosition);

       globalLayers.graphicLayerLocation!.graphics.on("change", (event) => {
        console.log(event)
        if (event.added && event.added.length > 0) {
            event.added.forEach((graphic: __esri.Graphic) => {
                console.log("Graphic added to layer:", graphic);
                console.log(globalLayers.sketchLayers?.graphics)
                // your logic here
            });
        }
    });
 
};
